import {Component} from 'react';


class Config extends Component {

    VERSION = "0.0.1";
    API_PATH = null;
    COOKIE_MAX_AGE = 86400 * 7;

    constructor() {

        super();

        this.API_PATH = API_PATH;// eslint-disable-line

        if (typeof COOKIE_MAX_AGE !== 'undefined') {
            this.COOKIE_MAX_AGE = COOKIE_MAX_AGE;// eslint-disable-line
        }

    }

    //API_PATH;
    getApiPath() {

        if (!this.API_PATH)
            throw new Error("API_PATH IS NOT SET");

        return this.API_PATH;

    }

    getCookieMaxAge() {

        return this.COOKIE_MAX_AGE;

    }

    getVersion() {

        return this.VERSION;

    }

}

export default Config;